import React, { useEffect, useState } from "react";
import { serialize } from "object-to-formdata";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Layout, Button, Divider, Drawer, List, Badge, Input, Image, Form, Spin, notification } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { RightSquareOutlined } from "@ant-design/icons";
import Axios from "axios";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { actions as RetailerActions } from "../../../redux/resources/retailer";
import CustomDivider from "../../../components/Divider";
import { getAuthData, getUserTenant } from "../../../helpers/authStorage";
import { API_URL } from "../../../constants/config";
import SimpleLocationModal from "../../../components/DataEntry/SimpleMapCoordinateDrawer";

import "./style.less";
import { getPhoneInputCountryCode } from "../../../helpers/general";
import { customFetch } from "../../../utils/customFetch";

const formItemLayout = {
  layout: "vertical",
};

const RetailerAccount = ({
  isAdmin,
  retailer,
  getSelfInfoRetailer,
  cancelUpdateSelfRetailer,
  getLastPendingUpdateSelfRetailer,
}) => {
  const { Content } = Layout;
  // const intl = useIntl();
  const [accountData, setAccountData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mainFieldsLocked, setMainFieldsLocked] = useState(false);
  const [lastRequest, setLastRequest] = useState(false);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [updatesSummary, setUpdatesSummary] = useState([]);

  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const [locationForModal, setLocationForModal] = useState({ lat: 0, long: 0 });

  const [form] = Form.useForm();
  const intl = useIntl();

  useEffect(() => {
    if (isAdmin) {
    } else {
      updateForm();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isAdmin) {
      // set loaded retailer for admin
    } else {
      //
    }

    // eslint-disable-next-line
  }, []);

  const getStatusBg = () => {
    let color = "black";
    switch (retailer?.status) {
      case "pending":
        color = "rgba(252, 220, 62, 1)";
        break;
      case "accepted":
        color = "rgba(39, 174, 96, 1)";
        break;
      case "rejected":
        color = "rgba(235, 87, 87, 1)";
        break;
      default:
        break;
    }
    return {
      color,
      border: `1px solid ${color}`,
      background: "transparent",
      borderRadius: "5px",
      width: 110,
      textAlign: "center",
      textTransform: "capitalize",
    };
  };

  const updateForm = () => {
    setLoading(true);
    getSelfInfoRetailer().then((res) => {
      const retailer = res.body;
      let defaultPickup = retailer?.pickupPoints?.filter((e) => e?.main)?.[0];

      // in case a default pickup with `main == true` doesn't exist
      // we pick the first availble pickup point registered in retailer data
      if (!defaultPickup) defaultPickup = retailer?.pickupPoints?.[0];

      setAccountData({
        ...retailer,
        pickupPoint: { ...defaultPickup },
      });
      form.setFieldsValue({
        ...retailer,
        pickupPoint: { ...defaultPickup },
      });

      customFetch(retailer?.commercialRegistration?.url)
        .then((res) => {
          return res.blob();
        })
        .then((blob) => {
          setImage(blob);
          setImageChanged(false);
          const reader = new FileReader();
          reader.onloadend = () => {};
          reader.readAsDataURL(blob);
        })
        .catch((err) => {
          // to avoid blocking the form edditing process
          notification.warn({ description: "Failed to get commercial Registration informations ! " });
        });
      getLastPendingUpdateSelfRetailer().then(({ body }) => {
        if (body?.status === "pending") {
          setMainFieldsLocked(true);
          setLastRequest(body);
        } else {
          setMainFieldsLocked(false);
        }
      });
      setLoading(false);
    });
  };

  const onOpenChanges = () => () => {
    setDrawerOpen(true);
    const updates = lastRequest?.updatePayload;
    setUpdatesSummary(
      Object.keys(lastRequest?.updatePayload).map((key) => {
        if (key === "commercialRegistration") {
          return {
            index: key.replace(/[A-Z]/g, (letter) => ` ${letter.toLowerCase()}`),
            old: retailer[key],
            new: updates[key],
          }; // eslint-disable-next-line
        } else if (key === "pickupPoint") {
          return {
            index: key.replace(/[A-Z]/g, (letter) => ` ${letter.toLowerCase()}`),
            // eslint-disable-next-line
            old: retailer[key + "s"]?.filter((e) => e.id === updates[key].id)?.[0],
            new: updates[key],
          };
        } else
          return {
            index: key.replace(/[A-Z]/g, (letter) => ` ${letter.toLowerCase()}`),
            old: retailer[key],
            new: updates[key],
          };
      }),
    );
  };

  const handleMapInput = (input) => {
    form.setFieldsValue({ ...form.getFieldsValue(true), pickupPoint: input });
  };

  const onFinish = (values) => {
    setLoading(true);
    const { name, phoneNumber, supportNumber, officeAddress, pickupPoint, pointOfContact } = values;
    const newValues = {
      phoneNumber,
      supportNumber,
      officeAddress,
      pointOfContact: JSON.stringify(pointOfContact),
    };
    if (name !== retailer.name) {
      newValues.name = name;
    }
    const defaultPickup = retailer?.pickupPoints?.filter((e) => e?.main)?.[0];
    // at least one default pickup point needs to exist
    if (
      !defaultPickup ||
      pickupPoint.lat !== defaultPickup.lat ||
      pickupPoint.long !== defaultPickup.long ||
      pickupPoint.address !== defaultPickup.address ||
      pickupPoint.instructions !== defaultPickup.instructions
    ) {
      newValues.pickupPoint = JSON.stringify({
        address: pickupPoint?.address,
        lat: Number(pickupPoint?.lat),
        long: Number(pickupPoint?.long),
        instructions: pickupPoint?.instructions,
      });
    }
    if (imageChanged) {
      newValues.commercialRegistration = image;
    }
    Axios.put(`${API_URL}/retailers/self/info`, serialize(newValues), {
      headers: {
        "Content-Type": "multipart/formdata",
        Authorization: `Bearer ${getAuthData().accessToken}`,
        Tenant: getUserTenant(),
      },
    }).then((res) => {
      updateForm();
      setImageChanged(false);
    });
  };

  const [image, setImage] = useState();
  const [imageURL, setImageURL] = useState();
  const [imageChanged, setImageChanged] = useState(false);
  useEffect(() => {
    if (image) {
      const newImageURL = URL.createObjectURL(image);
      setImageURL(newImageURL);
      customFetch(newImageURL)
        .then((res) => res.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {};
          reader.readAsDataURL(blob);
        });
    }
  }, [image]);

  const onImageChange = (e) => {
    setImage(e.target.files[0]);
    setImageChanged(true);
  };

  return (
    <>
      <Content className="retailerCabinetContent retailerSettingsContent" style={{ paddingTop: 0 }}>
        <h2 className="pageTitle">
          <FormattedMessage id="page.home.settings.account.pagetitle" defaultMessage="Account settings" />
        </h2>
        <CustomDivider />
        <Spin spinning={loading}>
          {mainFieldsLocked && (
            <div
              style={{
                float: "right",
                marginRight: "15%",
                marginBottom: "20px",
                display: "flex",
                gap: 10,
                alignItems: "center",
              }}
            >
              <strong>
                {" "}
                <FormattedMessage
                  id="page.home.settings.account.warning"
                  defaultMessage="You have pending edit request"
                />
              </strong>
              <Button onClick={onOpenChanges()}>
                {" "}
                <FormattedMessage id="page.home.settings.account.warning.view" defaultMessage="View" />
              </Button>
              <Button
                danger
                onClick={() => {
                  cancelUpdateSelfRetailer(lastRequest?.id).then(() => {
                    updateForm();
                  });
                }}
              >
                <FormattedMessage id="page.home.settings.account.warning.cancel" defaultMessage="Cancel" />
              </Button>
            </div>
          )}
          <Divider />
          <Form {...formItemLayout} onFinish={onFinish} initialValues={accountData} form={form}>
            <Form.Item
              label={`${intl.formatMessage({
                id: "page.home.settings.account.form.retailerinfo",
                defaultMessage: "Retailer Info",
              })}`}
              className="retailerAccount-formBlock"
            >
              <Form.Item
                label={`${intl.formatMessage({
                  id: "page.home.settings.account.form.retailerinfo.email",
                  defaultMessage: "Email",
                })}`}
                name="email"
              >
                <Input disabled />
              </Form.Item>
              <Form.Item
                label={`${intl.formatMessage({
                  id: "page.home.settings.account.form.retailerinfo.name",
                  defaultMessage: "Name",
                })}`}
                name="name"
                rules={[{ required: true }]}
              >
                <Input disabled={mainFieldsLocked} />
              </Form.Item>
              <Form.Item
                label={`${intl.formatMessage({
                  id: "page.home.settings.account.form.retailerinfo.address",
                  defaultMessage: "Office Address",
                })}`}
                name="officeAddress"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label={`${intl.formatMessage({
                  id: "page.home.settings.account.form.retailerinfo.phone",
                  defaultMessage: "Phone Number",
                })}`}
                name="phoneNumber"
                rules={[{ required: true }]}
              >
                <ReactPhoneInput
                  defaultMask={".... .... ...."}
                  country={getPhoneInputCountryCode()}
                  placeholder={`${intl.formatMessage({ id: "input.phone", defaultMessage: "Phone" })}`}
                />
              </Form.Item>
              <Form.Item
                label={`${intl.formatMessage({
                  id: "page.home.settings.account.form.retailerinfo.support",
                  defaultMessage: "Support Number",
                })}`}
                name="supportNumber"
                rules={[{ required: true }]}
              >
                <ReactPhoneInput
                  defaultMask={".... .... ...."}
                  country={getPhoneInputCountryCode()}
                  placeholder={`${intl.formatMessage({ id: "input.phone", defaultMessage: "Phone" })}`}
                />
              </Form.Item>
              <Form.Item
                label={`${intl.formatMessage({
                  id: "page.home.settings.account.form.retailerinfo.status",
                  defaultMessage: "Status",
                })}`}
                name="status"
              >
                <Input disabled style={getStatusBg()} />
              </Form.Item>
            </Form.Item>
            <Form.Item
              label={`${intl.formatMessage({
                id: "page.home.settings.account.form.address",
                defaultMessage: "Address And Instructions",
              })}`}
              className="retailerAccount-formBlock"
            >
              <Form.Item
                label={`${intl.formatMessage({
                  id: "page.home.settings.account.form.address.address",
                  defaultMessage: "Pick Up Address",
                })}`}
                name={["pickupPoint", "address"]}
                rules={[{ required: true }]}
              >
                <Input.Search
                  disabled={mainFieldsLocked}
                  onSearch={() => {
                    setLocationForModal(form.getFieldsValue(true)?.pickupPoint);
                    setIsLocationModalOpen(true);
                  }}
                />
              </Form.Item>
              <Form.Item
                label={`${intl.formatMessage({
                  id: "page.home.settings.account.form.address.instructions",
                  defaultMessage: "Pick Up Instructions",
                })}`}
                name={["pickupPoint", "instructions"]}
              >
                <Input disabled={mainFieldsLocked} />
              </Form.Item>
              <Form.Item label="Lat" name={["pickupPoint", "lat"]} rules={[{ required: true }]}>
                <Input disabled={mainFieldsLocked} />
              </Form.Item>
              <Form.Item label="Lng" name={["pickupPoint", "long"]} rules={[{ required: true }]}>
                <Input disabled={mainFieldsLocked} />
              </Form.Item>
            </Form.Item>
            <Form.Item
              label={`${intl.formatMessage({
                id: "page.home.settings.account.form.contact",
                defaultMessage: "Main Point Of Contact",
              })}`}
              className="retailerAccount-formBlock"
            >
              <Form.Item
                label={`${intl.formatMessage({
                  id: "page.home.settings.account.form.contact.first",
                  defaultMessage: "First Name",
                })}`}
                name={["pointOfContact", "firstName"]}
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label={`${intl.formatMessage({
                  id: "page.home.settings.account.form.contact.last",
                  defaultMessage: "Last Name",
                })}`}
                name={["pointOfContact", "lastName"]}
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label={`${intl.formatMessage({
                  id: "page.home.settings.account.form.contact.number",
                  defaultMessage: "Contact Number",
                })}`}
                name={["pointOfContact", "phoneNumber"]}
                rules={[{ required: true }]}
              >
                <ReactPhoneInput
                  defaultMask={".... .... ...."}
                  country={getPhoneInputCountryCode()}
                  placeholder={`${intl.formatMessage({ id: "input.phone", defaultMessage: "Phone" })}`}
                />
              </Form.Item>
            </Form.Item>
            <Form.Item
              label={`${intl.formatMessage({
                id: "page.home.settings.account.form.document",
                defaultMessage: "Commercial Registration",
              })}`}
              className="retailerAccount-formBlock"
            >
              <Form.Item
                label={`${intl.formatMessage({
                  id: "page.home.settings.account.form.document.document",
                  defaultMessage: "Document",
                })}`}
              >
                <Image
                  width={200}
                  height={200}
                  src={accountData?.commercialRegistration?.url}
                  fallback="data:image/png;base64,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"
                />
                <Form.Item>
                  <Button style={{ marginTop: "10px" }} type="primary" htmlType="submit">
                    <FormattedMessage id="page.home.settings.account.form.submit" defaultMessage="Submit Changes" />
                  </Button>
                </Form.Item>
              </Form.Item>
              <Form.Item
                label={`${intl.formatMessage({
                  id: "page.home.settings.account.form.document.newdocument",
                  defaultMessage: "Upload New",
                })}`}
              >
                {imageURL && imageChanged && <Image width={200} height={200} src={imageURL} />}
                <Form.Item name="newDocument" noStyle>
                  <Input
                    type="file"
                    accept="image/*"
                    onChange={onImageChange}
                    disabled={mainFieldsLocked}
                    className={`retailerAccount-newFile ${
                      imageURL && imageChanged && "retailerAccount-newFile-uploaded"
                    }`}
                  />
                  <div
                    className={`retailerAccount-newFile-uploadFileText ${
                      imageURL && imageChanged && "retailerAccount-newFile-uploadFileText-uploaded"
                    }`}
                  >
                    <FormattedMessage
                      id="page.home.settings.account.form.document.newfile"
                      defaultMessage="Upload File"
                    />
                  </div>
                </Form.Item>
              </Form.Item>
            </Form.Item>
          </Form>
        </Spin>
      </Content>
      <Drawer width="80vw" placement="right" closable onClose={() => setDrawerOpen(false)} visible={isDrawerOpen}>
        <List
          header={
            <div>
              <FormattedMessage id="page.home.settings.account.drawer.title" defaultMessage="Review changes:" />
            </div>
          }
          bordered
          dataSource={updatesSummary}
          renderItem={(item) => {
            if (item.old instanceof Object || !item.old) {
              return Object.keys(item.new).map((key) => (
                <>
                  {!["id", "path", "createdAt"].includes(key) &&
                    item.old[key] !== item.new[key] &&
                    String(item.old[key]) !== String(item.new[key]) && (
                      <List.Item>
                        {key !== "url" ? (
                          <>
                            <strong> {key}:</strong>
                            {item.old[key]}
                            <div style={{ margin: "0 10px", color: "#01cdfb" }}>
                              <RightSquareOutlined />
                            </div>
                            {item.new[key]}
                          </>
                        ) : (
                          <>
                            <List.Item.Meta
                              title={<strong>Changed document:</strong>}
                              description={
                                <>
                                  <div style={{ width: "40%" }}>
                                    <Badge.Ribbon text="Old">
                                      <Image src={item.old[key]} />
                                    </Badge.Ribbon>
                                  </div>
                                  <div style={{ width: "40%" }}>
                                    <Badge.Ribbon text="New">
                                      <Image src={item.new[key]} />
                                    </Badge.Ribbon>
                                  </div>
                                </>
                              }
                            />
                          </>
                        )}
                      </List.Item>
                    )}
                </>
              ));
              // eslint-disable-next-line
            } else {
              // eslint-disable-next-line
              return (
                <>
                  {item.old !== item.new && (
                    <List.Item>
                      <strong> Changed {item.index} :</strong>
                      <br /> {item.old}
                      <span style={{ margin: "0 10px", color: "#01cdfb" }}>
                        {" "}
                        <RightSquareOutlined />{" "}
                      </span>
                      {item.new}
                    </List.Item>
                  )}
                </>
              );
            }
          }}
        />
      </Drawer>
      <SimpleLocationModal
        location={locationForModal}
        setIsLocationModalOpen={setIsLocationModalOpen}
        isLocationModalOpen={isLocationModalOpen}
        submitLocation={handleMapInput}
      />
    </>
  );
};

const MSTP = (state) => {
  return { retailer: state.retailer.retailerData };
};

export default connect(MSTP, (dispatch) => ({
  ...bindActionCreators(RetailerActions, dispatch),
}))(RetailerAccount);
